import { computed, ref } from "vue";
import ImageFallback from "../../components/imageFallback.js";
import Store from "../../store.js";
import { getMemberAvatar, getMemberDisplayName, getMemberTag } from "../../utils.js";

export default {

    props: [ "log", "members", "channels" ],

    setup(props) {
        const refRoles = ref(new Map());
        const refMember = computed(() => props.members.value.get(props.log.executor));

        const refExtraRoles = computed(() => {
            const roles = [];

            for (const extraRole of props.log.extra.roles) {
                if (extraRole.id !== Store.selectedGuild.id) {
                    const role = refRoles.value.get(extraRole.id);

                    roles.push(role || extraRole);
                }
            }

            return roles;
        });

        fetch("/api/roles").then((res) => res.json()).then((roles) => {
            refRoles.value = new Map(roles.map((role) => [role.id, role]));
        });

        return () => {
            const log = props.log;

            if (log.type === "member_leave") {
                const member = refMember.value;

                console.log(log);

                return (
                    <div class="log-preview">
                        <router-link to={`/users/${log.executor}`} class="log-presence-user log-voice-user">
                            <div class="log-presence-avatar-container">
                                <ImageFallback class="log-presence-avatar-image" src={getMemberAvatar(member)} default="https://cdn.discordapp.com/embed/avatars/0.png" alt={getMemberDisplayName(member)} />
                            </div>

                            <div class="log-presence-name">
                                <div class="log-presence-displayname">
                                    {getMemberDisplayName(member)}
                                </div>

                                <div class="log-presence-username">
                                    {getMemberTag(member)}
                                </div>
                            </div>
                        </router-link>

                        <div class="log-section-label">Rôles avant de quitter</div>

                        <div class="log-member-roles">
                            {refExtraRoles.value.map((role) => {
                                console.log(role);

                                return (
                                    <div class="log-member-role">
                                        {role.name}
                                    </div>
                                );
                            })}
                        </div>

                        {member?.available && (
                            <>
                                <div class="log-section-label">Rôles actuels</div>

                                <div class="log-member-roles">
                                    {member.serverRoles.map((roleId) => {
                                        const role = refRoles.value.get(roleId);

                                        if (role) {
                                            return (
                                                <div class="log-member-role">
                                                    {role.name}
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                );
            }

            return (
                <div>
                    test
                </div>
            );
        };
    },
}
